const API_URL = process.env.REACT_APP_API_URL || 'https://parivarsuraksha.org/api/save_registration.php';

export interface RegistrationPayload {
  basicDetails?: any;
  nomineeDetails?: any;
  healthDeclaration?: any;
}

export interface AttachmentsFiles {
  photo?: File | null;
  signPhoto?: File | null;
  adhaarCard?: File | null;
  panCard?: File | null;
  nomineeAdhaarCard?: File | null;
}

export async function submitRegistration(
  payload: RegistrationPayload,
  files?: AttachmentsFiles,
  onProgress?: (progress: number) => void
) {
  const form = new FormData();
  form.append('data', JSON.stringify(payload));

  if (files) {
    if (files.photo) form.append('photo', files.photo);
    if (files.signPhoto) form.append('signPhoto', files.signPhoto);
    if (files.adhaarCard) form.append('adhaarCard', files.adhaarCard);
    if (files.panCard) form.append('panCard', files.panCard);
    if (files.nomineeAdhaarCard) form.append('nomineeAdhaarCard', files.nomineeAdhaarCard);
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    // Track upload progress
    if (onProgress) {
      xhr.upload.addEventListener('progress', (event: ProgressEvent) => {
        if (event.lengthComputable) {
          const percentComplete = Math.round((event.loaded / event.total) * 100);
          onProgress(percentComplete);
        }
      });
    }

    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const json = JSON.parse(xhr.responseText);
          if (json.success) {
            resolve(json);
          } else {
            reject(new Error(json.message || 'Upload failed'));
          }
        } catch (e) {
          reject(new Error('Invalid JSON response from server'));
        }
      } else {
        try {
          const json = JSON.parse(xhr.responseText);
          reject(new Error(json.message || `Server error: ${xhr.status}`));
        } catch {
          reject(new Error(`Server error: ${xhr.status}`));
        }
      }
    });

    xhr.addEventListener('error', () => {
      reject(new Error('Network error during upload'));
    });

    xhr.addEventListener('abort', () => {
      reject(new Error('Upload cancelled'));
    });

    xhr.open('POST', API_URL, true);
    xhr.send(form);
  });
}
